module.exports = __webpack_public_path__ + "media/images/vouchers/spa-ce2d0d3175f4ca92cb6e8e3f085807f3.png";